import React from "react";
import { PropsWithChildren } from "react";
import { useMapActions } from "./configurableActions";

export interface IMapBoundaryProviderProps {
  drawRef: React.MutableRefObject<MapboxDraw | null>;
  saveBtnRef?: React.MutableRefObject<HTMLButtonElement | null>;
  deleteBtnRef?: React.MutableRefObject<HTMLButtonElement | null>;
}

export const MapProvider: React.FC<
  PropsWithChildren<IMapBoundaryProviderProps>
> = ({ children, drawRef, saveBtnRef, deleteBtnRef }) => {
  useMapActions({ drawRef, saveBtnRef, deleteBtnRef });
  return <>{children}</>;
};
